<template>
  <div class="toolbar" :class="classes" :style="styles">
    <LuminanceMask
      class="toolbar__bg-left"
      :src="require('@/assets/images/other/toolbar-bg-left.jpg')"
      :stop-colors="[{ offset: '50%', color: resultTitleColor }]"
    />
    <div class="toolbar__bg">
      <LuminanceMask
        class="toolbar__bg-img"
        :src="require('@/assets/images/other/toolbar-bg-main.jpg')"
        :stop-colors="[{ offset: '50%', color: resultColor }]"
      />
    </div>
    <div v-if="$slots.title" class="toolbar__title">
      <component :is="titleTag" class="toolbar__title-content">
        <slot name="title" />
      </component>
      <div class="toolbar__title-bg-container"></div>
    </div>
    <div v-if="$slots.default" class="toolbar__content">
      <slot />
    </div>
    <div v-if="$slots.extension" class="toolbar__extension">
      <slot name="extension" />
    </div>
  </div>
</template>

<script>
import "./Toolbar.scss";
import LuminanceMask from "@/components/ui/masks/LuminanceMask";

const colors = {
  1: "#de0b42",
  2: "#0f8acb", // "#00243f",
  3: "#0f8acb"
};

export default {
  name: "Toolbar",
  components: {
    LuminanceMask
  },
  props: {
    titleTag: {
      type: String,
      default: "div"
    },
    color: {
      type: [String, Number],
      default: 1
    },
    titleColor: [String, Number]
  },
  computed: {
    classes() {
      return {
        "toolbar_with-content": !!this.$slots.default
      };
    },
    styles() {
      return {
        color: this.resultColor
      };
    },
    resultColor() {
      return colors[this.color] || this.color;
    },
    resultTitleColor() {
      const { titleColor, resultColor } = this;
      return titleColor ? colors[titleColor] || titleColor : resultColor;
    }
  }
};
</script>
